// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"5b7ce3c3","787":"c1112931","981":"6e541656"}[chunkId] + ".chunk.js";
};